// extracted by mini-css-extract-plugin
export default {"btnEdit":"prices-update-modal_btnEdit__tirTb"};